import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const CatInBoxIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="url(#dhl__illustrations_catinboxillustration_svg_a)"
      d="m106.285 142.333 37.15-6.728-.795-3.364.596-3.738-70.128-32.706-47.679 8.784z"
      opacity={0.5}
    />
    <path fill="#996A0D" d="m104.298 126.821 21.853-3.925-43.904-20.558-21.655 3.925z" />
    <path fill="#FDDE84" d="m126.151 57.671 77.082-12.895-43.905-20.558L82.247 37.3z" />
    <path fill="#996A0D" d="m126.151 57.671 17.681-9.718-43.706-20.558-17.88 9.905z" />
    <path fill="#634509" d="M126.151 57.671v65.225l-43.904-20.558V37.3z" />
    <path fill="#C39000" d="M61.784 34.123v64.29l20.463 3.925V37.3z" />
    <path
      fill="url(#dhl__illustrations_catinboxillustration_svg_b)"
      d="m100.325 127.755 25.826-4.859V93.741l-69.73 13.456z"
      opacity={0.5}
    />
    <path fill="#926608" d="m121.185 114.673-45.892-7.849 26.224-12.148 45.891 7.662z" />
    <path
      fill="url(#dhl__illustrations_catinboxillustration_svg_c)"
      d="m120.39 119.345-24.038-2.429 6.158-5.046 8.94-2.43 37.945.748z"
      opacity={0.3}
    />
    <path
      fill="#C9CAC9"
      d="M71.717 110.187c-.993 2.243 2.186 5.607 7.152 7.476s9.735 1.495 10.728-.748c.993-2.242-2.185-5.606-7.152-7.475-2.582-.935-3.774-2.99-5.761-2.804-2.185.561-3.973 1.869-4.967 3.551M137.872 74.678c-3.576-2.243-7.747-3.364-11.919-3.364-3.775 0-7.351.748-10.53 2.43-2.781 1.495-6.357 4.111-12.714 2.616l-5.761 36.07 14.899 1.682s24.039 2.616 31.985-1.682c0 0 8.543-9.158 3.775-25.604-.199.187-1.589-5.98-9.735-12.148"
    />
    <path fill="#E5E5E5" d="m81.452 80.098-5.364-5.793s-1.987-1.496-2.185 1.308l.596 10.466" />
    <path fill="#C9C9C9" d="m79.664 79.724-2.98-3.177s-.993-.934-1.192.748l.397 5.793" />
    <path
      fill="#B8B9B8"
      d="M76.088 76.173c-.397 0-.596 0-.795.935l.398 5.793M143.634 112.617s-4.172-4.111-8.344-4.672-8.543 2.243-10.927 1.869c-7.748-1.122-13.112-9.345-13.112-9.345s-4.172 5.046-8.542 10.466-2.384 1.495-2.384 1.495l-10.53-2.616 2.782 2.99s7.549 1.308 8.543 1.308 14.502.561 15.098.561 20.661 1.869 27.416-2.056"
    />
    <path
      fill="#C9CAC9"
      d="M104.532 119.074c5.292-.892 9.205-3.592 8.74-6.03s-5.13-3.692-10.422-2.8-9.205 3.593-8.74 6.031 5.13 3.692 10.422 2.799"
    />
    <path
      fill="#B8B9B8"
      d="M94.762 114.86c.398 1.121 2.186 1.495 4.172.934 1.987-.561 6.358-5.046 6.358-5.794h-.398c-2.582.187-4.966.935-7.35 1.869-.795.374-1.391.748-1.987 1.309s-.993 1.121-.795 1.682M88.803 113.365c-.398 1.121-2.384 1.121-4.371.561-1.987-.561-9.337-6.355-8.94-7.476s8.344 3.177 10.33 3.738 3.378 2.242 2.98 3.177"
    />
    <path
      fill="#E5E5E5"
      d="M91.584 113.738c12.069 0 21.853-8.869 21.853-19.81s-9.784-19.81-21.853-19.81-21.853 8.87-21.853 19.81c0 10.941 9.784 19.81 21.853 19.81"
    />
    <path
      fill="#C9C9C9"
      d="m75.293 98.227-.198-.374c2.781-.748 5.761-.56 8.542.374v.373c-2.781 0-5.562.561-7.946 1.869l-.199-.373c2.185-1.122 4.57-1.682 6.953-1.87a15.4 15.4 0 0 0-7.152 0M90.193 98.6c3.179-1.121 6.556-1.121 9.536 0l-.199.374c-2.582-.934-5.364-1.121-8.145-.374 2.583.187 4.967.935 7.152 2.056l-.199.374c-2.582-1.308-5.364-2.056-8.145-2.056z"
    />
    <path fill="#E5E5E5" d="M104.497 83.088v-8.036c-.596-2.99-3.179-1.122-3.179-1.122l-4.768 4.673" />
    <path fill="#C9C9C9" d="m96.948 79.724 3.774-3.737s1.59-1.122 1.987.747v5.42" />
    <path
      fill="#B8B9B8"
      d="m99.332 80.845-2.384-.934 3.774-3.738c.398-.187.795-.374 1.192-.374-.397.374-.794.561-1.192 1.122-.198.373-.596.934-.596 1.308l-.596 1.869z"
    />
    <path
      fill="#000"
      d="M95.756 94.302c.768 0 1.39-.586 1.39-1.308s-.622-1.308-1.39-1.308-1.39.585-1.39 1.308c0 .722.622 1.308 1.39 1.308M80.061 94.302c.768 0 1.39-.586 1.39-1.308s-.622-1.308-1.39-1.308-1.39.585-1.39 1.308c0 .722.622 1.308 1.39 1.308"
    />
    <path
      fill="#B8B9B8"
      d="M135.687 73.557c.199 0 16.092 8.97 3.179 12.895S119.198 72.25 119.198 72.25s9.139-2.804 16.489 1.308M125.754 103.833c3.84 0 6.953-2.259 6.953-5.046s-3.113-5.046-6.953-5.046-6.953 2.26-6.953 5.046 3.113 5.046 6.953 5.046"
    />
    <path
      fill="#C9C9C9"
      d="M84.307 86.489c4.183-2.052 6.464-5.72 5.094-8.19-1.37-2.471-5.872-2.81-10.055-.759-4.183 2.053-6.464 5.72-5.094 8.19 1.37 2.472 5.871 2.811 10.055.759"
    />
    <path fill="#D20612" d="m87.015 99.535-2.583-2.804h5.562z" />
    <path fill="#FCCE09" d="M126.151 57.671v65.225l77.081-13.082V44.776z" />
    <path fill="#FDDE84" d="M126.151 57.671v65.225l17.482 13.269V70.193z" />
    <path
      fill="#E5E5E5"
      d="M85.425 100.843s0 1.869 1.59 2.056c0 0 1.589.187 1.589-1.869 0 0-1.59-.935-1.788-1.495a4.5 4.5 0 0 1-1.39 1.308"
    />
    <path
      fill="#8E8E8E"
      d="M80.459 99.16c.198 0 .397 0 .397.188.397.934 1.39 1.495 2.384 1.682 1.39.373 2.781-.374 3.576-1.496h.198c.597.935 1.59 1.682 2.583 1.682 1.59.374 3.179-.186 3.973-1.495.199-.187.398-.187.398 0 .198.187.198.187 0 .374-.795 1.121-1.987 1.869-3.576 1.869h-.993c-1.192-.187-2.186-.748-2.782-1.682-.596.934-1.788 1.495-2.98 1.495h-.993c-1.192-.187-2.384-.934-2.781-2.056q-.299-.28 0-.56.297-.28.596 0"
    />
    <path
      fill="#000"
      fillOpacity={0.1}
      d="M181.777 101.404c.596-1.495-.596-3.364-1.987-3.177-.993.374-1.589 1.495-1.192 2.429.398 1.682 2.583 2.243 3.179.748M187.141 99.348c-.795.187-1.192 1.121-.994 1.869.398 1.495 1.987 1.682 2.583.561.596-1.122-.397-2.804-1.589-2.43M185.551 100.469c.596-1.495-.596-3.364-1.986-3.177-.993.374-1.589 1.495-1.192 2.43.397 1.869 2.384 2.243 3.178.747M182.969 102.339c-1.589.186-2.98 1.308-3.576 2.803-.397 1.682.795 3.551 2.384 2.99 1.192-.374 1.391-.934 2.384-1.121s1.391.187 2.582 0c1.788-.374 1.987-2.43.596-3.738-.993-1.308-2.781-1.682-4.37-.934M179.194 103.834c.596-1.122-.397-2.617-1.589-2.43-.795.374-1.192 1.121-.993 1.869.397 1.308 1.986 1.682 2.582.561M179.79 73.93c.596-1.494-.596-3.363-2.185-3.176-.993.373-1.589 1.495-1.192 2.43.795 1.868 2.781 2.242 3.377.747M185.154 71.875c-.795.374-1.192 1.121-.795 1.869.398 1.495 1.987 1.682 2.583.56.596-1.12-.596-2.616-1.788-2.43M183.565 72.996c.596-1.495-.596-3.364-2.185-3.177-.994.374-1.59 1.495-1.192 2.43.794 1.869 2.781 2.43 3.377.747M180.982 74.865c-1.589.187-2.98 1.308-3.576 2.803-.397 1.682.795 3.551 2.583 2.99 1.192-.373 1.391-.934 2.384-1.308.993-.373 1.39.187 2.582 0 1.788-.373 1.788-2.43.596-3.737-1.192-.935-2.979-1.309-4.569-.748M177.406 76.547c.596-1.121-.397-2.616-1.589-2.43-.795.374-1.192 1.122-.795 1.87.199 1.308 1.788 1.681 2.384.56M192.107 87.2c1.192-1.121.795-3.364-.596-3.55-.993-.188-1.787.747-1.986 1.681-.397 1.869 1.39 2.99 2.582 1.869M198.067 87.387c-.794-.187-1.589.56-1.589 1.308-.199 1.495 1.192 2.243 2.185 1.495s.596-2.616-.596-2.803M196.081 87.76c1.192-1.12.794-3.363-.596-3.55-.994-.187-1.788.748-1.987 1.869-.397 1.682 1.192 2.803 2.583 1.682M192.902 88.508c-1.589-.374-3.377 0-4.371 1.308-.993 1.308-.794 3.551.994 3.738 1.192 0 1.589-.374 2.582-.374.994 0 1.192.748 2.384 1.122 1.788.373 2.782-1.496 2.186-3.178-.596-1.495-2.186-2.616-3.775-2.616"
    />
    <path
      fill="#000"
      fillOpacity={0.1}
      d="M188.929 88.508c.993-.934.596-2.617-.596-2.803-.795 0-1.589.56-1.589 1.495-.398 1.308 1.191 2.242 2.185 1.308"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M96.55 84.957q1.788.28 2.98 1.682"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={0.3}
      d="M96.55 84.957q1.788.28 2.98 1.682M79.863 85.144c-1.192.187-2.186.748-2.98 1.495"
    />
    <defs>
      <linearGradient
        id="dhl__illustrations_catinboxillustration_svg_a"
        x1={77.3}
        x2={91.66}
        y1={140.8}
        y2={93.138}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.27} stopColor="#1D1D1B" stopOpacity={0} />
        <stop offset={0.93} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_catinboxillustration_svg_b"
        x1={87.455}
        x2={105.692}
        y1={122.065}
        y2={84.019}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.27} stopColor="#1D1D1B" stopOpacity={0} />
        <stop offset={0.93} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_catinboxillustration_svg_c"
        x1={126.938}
        x2={118.8}
        y1={121.075}
        y2={104.098}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.27} stopColor="#1D1D1B" stopOpacity={0} />
        <stop offset={0.93} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
